import initAdminSidebar from "@/js/addon/admin-sidebar";
import initBrandRangeSelects from "@/js/addon/brand-range-selects";
import initEcoscoreForm from "@/js/addon/ecoscore-form";
import initInputFile from "@/js/addon/input-file";
import initLoader from "@/js/addon/loader";
import initToasts from "@/js/addon/toast";
import initToggle from "@/js/addon/toggle";
import initLinkSelection from "@/js/addon/link-selection";
import initVideo from "@/js/addon/video";
import { init } from "@/js/app";
import App from "@/react/story/components/App";
import StoryEditor from "@/react/story/components/StoryEditor";
import Story from "@/react/story/components/viewers/ViewerStory";
import { Tooltip } from "bootstrap";
import "@/app.scss";
import "@/js/addon/autosize";
import "@/js/addon/form-filter";
import "@/js/addon/statistics-chart";
import "@/js/addon/temporary";
import "@/js/addon/wysiwyg";
import { createRoot } from "react-dom/client";

import.meta.glob([ "@/images/**" ]);

declare const story_data: Record<string, unknown> | undefined;

document.addEventListener("DOMContentLoaded", () => {

    initInputFile();
    initLoader();
    initToasts();
    initToggle();
    initLinkSelection();
    initVideo();
    initEcoscoreForm();
    initBrandRangeSelects();
    initAdminSidebar();
    init(document.body);

    document.querySelectorAll<HTMLElement>(".hero-title").forEach(hero => {
        setInterval(() => {
            const active = hero.querySelector("span.active");
            if (active) {
                active.classList.remove("active");
                const next = active.nextElementSibling || hero.querySelector("span");
                next?.classList.add("active");
            }
        }, 1500);
    });

    document.querySelectorAll<HTMLFormElement>("form[name='app_user']").forEach(form => {
        const role = form.querySelector<HTMLSelectElement>("select#app_user_role");
        const companies = form.querySelector("#app_user_companies")?.closest("fieldset");
        if (!role || !companies) {
            return;
        }

        const refresh = () => companies.classList.toggle("d-none", "ROLE_SUPER_ADMIN" === role.value);
        role.addEventListener("change", refresh);
        refresh();
    });

    document.querySelectorAll("[data-bs-toggle='tooltip']").forEach(el => new Tooltip(el as HTMLElement));

    const storyEditor = document.getElementById("story-editor");
    if (storyEditor && "undefined" !== typeof story_data) {
        createRoot(storyEditor).render((
            <App {...story_data as React.ComponentProps<typeof App>} isOnline={false}>
                <StoryEditor />
            </App>
        ));
    }

    const story = document.getElementById("story");
    if (story && "undefined" !== typeof story_data) {
        createRoot(story).render((
            <App {...story_data as React.ComponentProps<typeof App>} isOnline={true}>
                <Story />
            </App>
        ));
    }

});
